import ProgressBar from "./ProgressBar.component";

export default ProgressBar;
